import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const DashboardModule = lazy(loadModule);

export default DashboardModule;
